import { useTranslation } from 'react-i18next'
import { PurchaseTable } from 'views/pages/Teams/PurchaseTableCard/PurchaseTable'
import styled from 'styled-components'
import { Title } from '../TeamsTableCard/styled'
import { tableContainer } from '../styled'
import { useSingleEntity } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { TeamMargin } from 'modules/domain/teams/types'

const Container = styled.div`
  ${tableContainer};
  width: 448px;
`

export const PurchaseTableCard = () => {
  const { t } = useTranslation('teams')
  const [progress, teamsData = []] = useSingleEntity<TeamMargin[]>(endpoints.teamsMarginForCurrentMonth('seller'))

  return (
    <div>
      <Container>
        <Title>{t('buying')}</Title>
        <PurchaseTable teamsData={teamsData} progress={progress} />
      </Container>
    </div>
  )
}
